import React, {useCallback, useEffect} from 'react';
import PropTypes from 'prop-types';
import StyledSnackbar from './Snackbar.styles';
import Button from 'components/atoms/Buttons/Button/Button';
import {useComponentProps, useEffectEvent} from 'helpers/hooks/utils';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import utils from 'helpers/utils';

const Snackbar = React.forwardRef((props, ref) => {
  const {
    action,
    size,
    color,
    onClose,
    ButtonProps,
    ...innerProps
  } = useComponentProps({
    color: 'secondary',
    ...props
  }, 'Snackbar');

  innerProps.message = innerProps.message ?? '';
  if (action) {
    innerProps.action = (
      <Button variant="text"
              size="small"
              color={color}
              {...ButtonProps}>
        {action}
      </Button>
    );
  }

  const handleClickAway = (e) => {
    onClose?.(e, 'clickaway');
  }

  const onCloseEvent = useEffectEvent(onClose);
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onCloseEvent?.(e, 'escapeKeyDown');
      e.preventDefault();
      e.stopPropagation();
    }
  }, [onCloseEvent]);

  useEffect(() => {
    return utils.observeEvent(window, 'keydown', handleKeyDown);
  }, [handleKeyDown]);

  return <ClickAwayListener onClickAway={handleClickAway}>
    <StyledSnackbar ref={ref} {...innerProps} color={color} onClose={onClose} />
  </ClickAwayListener>
});

Snackbar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  message: PropTypes.string,
  action: PropTypes.string,
  onClose: PropTypes.func,
  ButtonProps: PropTypes.object
}

export default Snackbar;
